import { merge } from 'lodash';
import view from './view.json';
import { replace } from './replace';

export const danish = merge(view, replace);
